import PageLayout from '../components/PageLayout';

function Home({ children }) {
  return (
    <PageLayout>
      {children}
    </PageLayout>
  );
}

export default Home;
